import { apiClient } from './client'
import type {
  CommissionListParams,
  DepartmentCommissionListParams,
  MyCommissionsResponse,
  DepartmentCommissionsResponse,
} from '@/types/commission'

export const commissionApi = {
  /**
   * 获取我的佣金列表
   */
  getMyCommissions: async (params: CommissionListParams): Promise<MyCommissionsResponse> => {
    const searchParams = new URLSearchParams()
    searchParams.set('page', String(params.page || 1))
    searchParams.set('page_size', String(params.page_size || 30))

    if (params.commission_type) searchParams.set('commission_type', params.commission_type)
    if (params.status) searchParams.set('status', String(params.status))
    if (params.start_date) searchParams.set('start_date', params.start_date)
    if (params.end_date) searchParams.set('end_date', params.end_date)
    if (params.order_no) searchParams.set('order_no', params.order_no)

    const response = await apiClient.get<MyCommissionsResponse>(
      `/commissions/my?${searchParams.toString()}`
    )
    return response.data
  },

  /**
   * 获取部门佣金列表
   */
  getDepartmentCommissions: async (
    params: DepartmentCommissionListParams
  ): Promise<DepartmentCommissionsResponse> => {
    const searchParams = new URLSearchParams()
    searchParams.set('page', String(params.page || 1))
    searchParams.set('page_size', String(params.page_size || 30))

    if (params.department_id) searchParams.set('department_id', String(params.department_id))
    if (params.user_id) searchParams.set('user_id', String(params.user_id))
    if (params.commission_type) searchParams.set('commission_type', params.commission_type)
    if (params.status) searchParams.set('status', String(params.status))
    if (params.start_date) searchParams.set('start_date', params.start_date)
    if (params.end_date) searchParams.set('end_date', params.end_date)
    if (params.order_no) searchParams.set('order_no', params.order_no)
    if (params.customer_phone) searchParams.set('customer_phone', params.customer_phone)
    if (params.scope) searchParams.set('scope', params.scope)

    const response = await apiClient.get<DepartmentCommissionsResponse>(
      `/commissions/department?${searchParams.toString()}`
    )
    return response.data
  },
}
